import React from 'react';
import { useParams } from 'react-router';
import { Container, Grid, Tab, Tabs } from '@material-ui/core';
import { Link } from 'react-router-dom';
import UserList from './components/UserList';
import ClientEditSidebar, { ACTIVE_CLIENT_SIDEBAR_TAB_NAMES } from '../clientedit/ClientEditSidebar';

function ClientUsersPage() {
    const { clientId } = useParams();

    return (
        <Container fixed className="activity-edit page">
            <Grid className="pageWithSidebar">
                <ClientEditSidebar activeTab={ACTIVE_CLIENT_SIDEBAR_TAB_NAMES.users} />
                <Grid className="pageContent">
                    <UserList clientId={clientId} />
                </Grid>
            </Grid>
        </Container>
    );
}

export default ClientUsersPage;
